// Account Dropdown Logic
const accountIcon = document.querySelector('.account-dropdown-container');
if (accountIcon) {
    const dropdown = accountIcon.querySelector('.account-dropdown');
    accountIcon.addEventListener('click', () => {
        dropdown.style.display = dropdown.style.display === 'none' ? 'block' : 'none';
    });
}

// Phone Dropdown Logic
document.addEventListener('DOMContentLoaded', () => {
    const headerPhone = document.querySelector('.header-phone');
    if (headerPhone) {
        const phoneDropdown = headerPhone.querySelector('.phone-dropdown');
        headerPhone.addEventListener('click', () => {
            const isVisible = phoneDropdown.style.display === 'block';
            phoneDropdown.style.display = isVisible ? 'none' : 'block';
        });
    }
});